import { Dropdown } from 'primereact/dropdown';
import { Badge } from 'primereact/badge';
import { useAllUsersQuery } from '@bmwe/data/shared';
import {
  ALL_USERS_PAGE_SIZE,
  OWN_USER_VALUE,
  readDevUserSid,
  switchDevUser,
  toSimulatorOptions,
} from './devUserSwitch';

export function UserRoleSimulator() {
  const { data, isLoading } = useAllUsersQuery({ first: ALL_USERS_PAGE_SIZE });

  const selectedSid = readDevUserSid();
  const users = data?.allUsers?.edges?.map((e) => e.node) ?? [];
  const options = toSimulatorOptions(users);
  const isSimulated = selectedSid !== OWN_USER_VALUE;

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
      <Dropdown
        value={selectedSid}
        options={options}
        onChange={(e) => switchDevUser(e.value)}
        placeholder="Nutzer wechseln"
        showClear={false}
        disabled={isLoading}
        tooltip="DEV: Als anderen Nutzer anmelden"
        tooltipOptions={{ position: 'bottom' }}
        pt={{
          root: { style: { minWidth: '180px' } },
        }}
      />
      {isSimulated && <Badge value="SIM" severity="warning" />}
    </div>
  );
}
